module.exports = __webpack_public_path__ + "media/images/sqra-logo-3667f363480dabd977880fde4fe8e6b7.png";